const customTheme = {
  colors: {
    cream: '#D4C2B5',
    'cream-50': '#E7E1D7',
    darkBlue: '#183344',
    darkBlueTransparent: 'rgba(24, 51, 68, 0.9)',
    green: '#7CF1C7',
    lightBlue: '#AFDFFF',
    medBlue: '#38749D',
    'med-blue': '#38749D',
    'med-blue-25': 'rgba(56, 116, 157, 0.25)',
    medBlueTransparent: 'rgba(24, 51, 68, 0.70)',
    'med-blue-transparent': '#38749D40',
    'salmon-dark': '#79250B',
    'salmon-light': '#FF9473',
    tan: '#F7F4EC',
    white: '#FFFFFF',
    neutral: '#EAEEF0',
    'white-50': 'rgba(255, 255, 255, 0.50)',
    'white-100': '#D2D4D8',
    yellow: '#F5E695',
    gradient: {
      dark: 'linear-gradient(90deg, #204660 -1.45%, #0E1D27 101.45%)',
      linear: 'linear-gradient(270deg, #38749D 0%, rgba(56, 116, 157, 0.60) 100%)',
      progress: 'linear-gradient(90deg, #7CF1C7 0%, #FF9473 64.58%)',
    },
    'text-tertiary': '#0E1D2780',
  },
  typography: {
    fonts: {
      inter: 'Inter',
      libreBaskerville: '"Libre Baskerville"',
    },
  },
  textStyles: {
    'text-stepper-label': {
      color: 'darkBlue',
      fontFamily: 'inter',
      fontStyle: 'normal',
      fontSize: { base: '0.875rem', md: '1.375rem' },
      fontWeight: { base: 700, md: 600 },
      lineHeight: { base: '140%', md: '130%' },
    },
    'text-custom-inter-1875-bold': {
      color: 'text-primary',
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontSize: '1.875rem',
      fontWeight: 700,
      letterSpacing: '0.013rem',
      lineHeight: '1.89375rem',
      textDecoration: 'none',
    },
  },
};

export default customTheme;
